let get_parameter_by_name;

get_parameter_by_name = (name, search) => {
    // if the search parameter has not been passed in,
    // use the global location object to preserve
    // backwards compatibility
    if (search === undefined) {
        search = location.search;
    }
    let regex;
    let results;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    results = regex.exec(search);
    if (results === null) {
        return null;
    } else {
        try {
            return decodeURIComponent(results[1].replace(/\+/g, " "));
        } catch (e) {
            console.error(e);
            return null;
        }
    }
};

export default get_parameter_by_name;
